import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "es-modal" }
const _hoisted_2 = { class: "es-modal-header" }
const _hoisted_3 = { class: "es-modal-title" }
const _hoisted_4 = { class: "es-modal-body" }
const _hoisted_5 = { key: 0 }

import { Dialog } from 'primevue';

type ModalProps = {
    title: string;
    isOpen: boolean;
    dismissable?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'esModal',
  props: {
    title: {},
    isOpen: { type: Boolean },
    dismissable: { type: Boolean }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const onUpdateVisible = (value: boolean) => {
    emits("update:visible", value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: props.isOpen,
    modal: "",
    draggable: false,
    closable: false,
    "dismissable-mask": props.dismissable,
    "close-on-escape": true,
    "onUpdate:visible": onUpdateVisible
  }, {
    container: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(props.title), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        (_ctx.$slots.footer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "footer")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["visible", "dismissable-mask"]))
}
}

})